var _a;
import TaskTypes from 'src/enums/TaskTypes';
var taskTypeToIntMap = (_a = {},
    _a[TaskTypes.WATCH_VIDEO] = 'watch-video',
    _a[TaskTypes.OPERATIONAL] = 'operation',
    _a[TaskTypes.GOVERNANCE] = 'governance',
    _a);
export default taskTypeToIntMap;



//////////////////
// WEBPACK FOOTER
// ./src/maps/taskTypeToIntlMap.ts
// module id = 832
// module chunks = 81